import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48831d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-url-redeemed" }
const _hoisted_2 = { class: "m-url-redemption" }
const _hoisted_3 = { class: "m-url-redemption-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("span", null, "▸"),
  /*#__PURE__*/_createElementVNode("span", null, "▸")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_token = _resolveComponent("m-token")!
  const _component_lazy_image = _resolveComponent("lazy-image")!
  const _component_m_redemption_button_section = _resolveComponent("m-redemption-button-section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_m_token, { token: _ctx.redemptionToToken }, null, 8, ["token"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_lazy_image, { src: _ctx.productImageSource }, null, 8, ["src"]),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.productIdToName(_ctx.currentSubmission.productId.toString())), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.variantIdToString(_ctx.currentSubmission.variantId.toString())), 1)
        ])
      ]),
      _hoisted_4
    ]),
    _createVNode(_component_m_redemption_button_section)
  ]))
}